import React, { useState } from "react";
import "react-sweet-progress/lib/style.css";

import HeadIcon from "../../common/images-new/head-icon.svg";
// import AssignmentIcon from "../../common/images-new/assignment-icon.svg";
// import ArchiveIcon from "../../common/images-new/archive-icon.svg";
import ButtonSquare from "../Button/ButtonSquare";
import { MdArchive, MdOutlineUnarchive } from "react-icons/md";
import { BsPin, BsPinFill } from "react-icons/bs";
import { serverUrl } from "../Helpers/Config";
import { getTeachingCourses } from "../../redux/actions/teachingCourses";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { ActiveIconColor, Card, TextGray } from "../../pages/Theme";
import PushPinIcon from "@mui/icons-material/PushPin";
import AssignmentIcon from "@mui/icons-material/Assignment";
import ArchiveOutlinedIcon from "@mui/icons-material/ArchiveOutlined";
import FaceOutlinedIcon from "@mui/icons-material/FaceOutlined";
import ArchiveIcon from "@mui/icons-material/Archive";
import UnarchiveIcon from "@mui/icons-material/Unarchive";
import { TbArchiveFilled } from "react-icons/tb";
import { TbArchiveOff } from "react-icons/tb";
import { Tooltip } from "@mui/material";

const CardCourse = ({ data }) => {
  const dispatch = useDispatch();

  const addPin = (e) => {
    e.stopPropagation();
    axios
      .post(serverUrl.TeachingCourses + `/pin/${data.group_id}`)
      .then((resp) => {
        if (resp.status === 200) {
          dispatch(getTeachingCourses());
        }
      });
  };
  const removePin = (e) => {
    e.stopPropagation();
    axios
      .delete(serverUrl.TeachingCourses + `/pin/${data.group_id}`)
      .then((resp) => {
        if (resp.status === 200) {
          dispatch(getTeachingCourses());
        }
      });
  };
  const addArchive = (e) => {
    e.stopPropagation();
    axios
      .post(serverUrl.TeachingCourses + `/archive/${data.group_id}`)
      .then((resp) => {
        if (resp.status === 200) {
          dispatch(getTeachingCourses());
        }
      });
  };

  const removeArchive = (e) => {
    e.stopPropagation();
    axios
      .delete(serverUrl.TeachingCourses + `/archive/${data.group_id}`)
      .then((resp) => {
        if (resp.status === 200) {
          dispatch(getTeachingCourses());
        }
      });
  };

  return (
    <Card className="relative w-full flex flex-col border20px shadow-sm text-base text-black p-5 md:p-5 md:px-6  px-3 md:text-base">
      <div className="flex justify-between mb-5 gap-2 items-start flex-wrap">
        <div className="blackColor md:text-xl font-bold break-anywhere ">
          {data.group_name}
        </div>
        <div className="flex items-center gap-1">
          {data?.is_archived ? (
            <Tooltip title={"Unarchive"} placement="top" arrow>
              <span>
                <TbArchiveOff
                  onClick={removeArchive}
                  style={{ fontSize: "25px" }}
                  className={`iconHover cursor-pointer secondaryIcon`}
                />
              </span>
            </Tooltip>
          ) : (
            <Tooltip title={"Archive"} placement="top" arrow>
              <span className="flex items-center">
                <TbArchiveFilled
                  onClick={addArchive}
                  style={{ fontSize: "24px" }}
                  className={`iconHover cursor-pointer secondaryIcon`}
                />
              </span>
            </Tooltip>
          )}
          {/* <ArchiveOutlinedIcon
            onClick={data.is_archived ? removeArchive : addArchive}
            style={{ fontSize: "27px" }}
            className={`iconHover cursor-pointer ${
              data.is_archived ? "primaryIcon" : "secondaryIcon"
            }`}
          /> */}
          <Tooltip
            title={data.is_pinned ? "Unpin" : "Pin"}
            placement="top"
            arrow
          >
            <span>
              <PushPinIcon
                onClick={data.is_pinned ? removePin : addPin}
                style={{ fontSize: "24px" }}
                className={`iconHover cursor-pointer ${
                  data.is_pinned ? "primaryIcon" : "secondaryIcon"
                }`}
              />
            </span>
          </Tooltip>
        </div>
      </div>

      <div className="flex flex-col space-y-4">
        <div className="flex flex-row content-center space-x-3 items-center">
          {/* <img src={HeadIcon} alt="participant-tutor"></img> */}
          <FaceOutlinedIcon
            style={{ fontSize: "35px" }}
            className="blueColor"
          />
          <span className="flex flex-col whitespace-nowrap blackColor">
            <p className="mr-1 ">{data.participant_count} Participants</p>
            <p className="mr-1 ">{data.tutor_count} Tutors</p>
          </span>
        </div>
        <div className="flex flex-row content-center space-x-3 items-center">
          <AssignmentIcon style={{ fontSize: "35px" }} className="blueColor" />
          {/* <img src={AssignmentIcon} alt="participant-tutor"></img> */}
          <div className="flex flex-col whitespace-nowrap">
            <p className="mr-1 blackColor">
              {data.task_list_count} Assignments
            </p>
            <p className="mr-1  blackColor">{data.task_list_active} On-going</p>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default CardCourse;
